import { useEffect, useRef } from 'react';

/**
 * Cuando el job de Renaper pasa de `corriendo` a un estado final (terminado o
 * error), el polling del resumen ya cortó (lo manejaba refetchInterval).
 * Invalidamos manualmente las queries asociadas para que los chips de la UI
 * y la tabla queden sincronizados con el resumen final del job.
 *
 * Extraído del cuerpo de PadronDetallePage para mantener su complejidad
 * cognitiva bajo el umbral de Sonar S3776.
 */
export function useRenaperJobEndInvalidation(
  estadoActual: string | undefined,
  onJobEnd: () => void,
): void {
  const estadoPrev = useRef<string | undefined>(undefined);
  useEffect(() => {
    const veniaCorriendo = estadoPrev.current === 'corriendo';
    const yaTermino = estadoActual !== undefined && estadoActual !== 'corriendo';
    if (veniaCorriendo && yaTermino) {
      onJobEnd();
    }
    estadoPrev.current = estadoActual;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estadoActual]);
}
